import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { headerTypographyProps } from '../styles/sxStyling';

interface IConfirmationModalProps {
  text: string | React.ReactNode;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmationModal({ text, isOpen, onCancel, onConfirm }: IConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <DialogTitle>
        <Typography {...headerTypographyProps}>Please confirm</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ m: 2 }}>{text}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
